module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_10.35a8cd08.jpg";